// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"InvitesModal_modalContent__h3Sg0"};